import { Err, Ok, Result } from 'ts-res';
import { KameleoonError, KameleoonException } from 'src/kameleoonError';
import { HTTP, HTTPS, LOCALHOST, REGEX_DOMAIN } from 'src/utilities/constants';
import { KameleoonLogger } from 'src/logging';

export class Validator {
  static validateVersion(
    version: string,
  ): Result<[number, number, number], KameleoonError> {
    const versionParts = version.split('.').map((x) => parseInt(x, 10));

    while (versionParts.length < 3) {
      versionParts.push(0);
    }

    if (versionParts.some((item) => isNaN(item))) {
      return Err(
        new KameleoonError(KameleoonException.SemanticVersionParse, version),
      );
    }

    return Ok(versionParts.slice(0, 3) as [number, number, number]);
  }

  static validateDomain(domain: string | undefined): Result<string, void> {
    if (!domain) {
      return Err();
    }

    domain = Validator.checkAndTrimProtocol(domain.toLowerCase());

    if (!REGEX_DOMAIN.test(domain) && domain !== LOCALHOST) {
      KameleoonLogger.error`The top-level domain ${domain} is invalid. The value has been set as provided, but it does not meet the required format for proper SDK functionality. Please check the domain for correctness.`;
      return Ok(domain);
    }

    return Ok(domain);
  }

  static validateNetworkDomain(networkDomain: string | undefined): Result<string, void> {
    if (!networkDomain) {
      return Err();
    }

    networkDomain = Validator.checkAndTrimProtocol(networkDomain.toLowerCase());

    // replace first and last dot
    networkDomain = networkDomain.replace(/^\.+|\.+$/g, '');

    if (!REGEX_DOMAIN.test(networkDomain) && networkDomain !== LOCALHOST) {
      KameleoonLogger.error`The network domain ${networkDomain} is invalid.`;
      return Err();
    }

    return Ok(networkDomain);
  }

  private static checkAndTrimProtocol(domain: string): string {
    const protocols = [HTTP, HTTPS];
    for (const protocol of protocols) {
      if (domain.startsWith(protocol)) {
        domain = domain.substring(protocol.length);
        KameleoonLogger.warning`The domain contains ${protocol}. Domain after protocol trimming: ${domain}`;
        break;
      }
    }

    return domain;
  }
}
